exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vocaloid-notice[data-v-3506ea95] {\n  margin: 8px auto 25px 0;\n  display: block;\n  font-size: 1.4rem;\n}\n.campaign-notification[data-v-3506ea95]{\n  margin-bottom:0;\n}\n.c-text-link[data-v-3506ea95]{\n  font-weight:bold;\n}\n", ""]);

// exports
